import { Box, Link, Button } from '@material-ui/core';
import { rgba } from 'polished';
import styled from 'styled-components';

export const PageHeaderContentContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const CustomLink = styled(Link)`
  display: flex;
  text-decoration: none;
  color: #000;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

/* export const CustomButton = styled(Button)`
  min-height: 40px;
  background-color: ${(props) => props.color || 'var(--color-blue-primary)'};
  color: ${(props) => props.textColor || 'var(--color-white)'};
  text-transform: uppercase;
  font-size: 11px;
  padding: 0 16px;
  border: 1px solid;
  border-color: #ccc;
  border-radius: 5px;

  &:hover {
    background-color: ${(props) =>
      props.color ? rgba(props.color, 0.5) : 'var(--color-blue-50)'};
  }
`; */
